// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"835":"8e67ca0d","996":"4ff19c83"}[chunkId] + ".chunk.js";
};